export const addressFileURL = 'https://fxit-dhb-tjb.oss-cn-hangzhou.aliyuncs.com/upload/ariesPreUat/region/address.js';
